import { createFileRoute } from '@tanstack/react-router';

import { SettingsPage } from '@/pages/utils/SettingsPage.tsx';

export const Route = createFileRoute('/(app)/utils/settings')({
  component: SettingsPage,
});
